import styled from 'styled-components';

export const WrapperPopover = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: fit-content;
  height: fit-content;
`;

export const WaterMark = styled.div<{ url: string }>`
  width: 100%;
  position: relative;

  &::before {
    content: ' ';
    background-image: url(${props => props.url});
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    width: 360px;
    height: 360px;

    opacity: 0.05;

    position: absolute;
    top: 240px;
    left: 50%;

    transform: translate(-50%, 0);
  }
`;
